import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

// Figma design-system "Checkbox" component (Square, 16px) - node 3:119 in the
// GypNZA59KaUz6qzMYxO3mE design-system file: white/#d7d7d7 border by default,
// secondary-green fill + primary-green border/checkmark when checked. A plain
// custom button (not dx-check-box) so it matches Figma's own asset/proportions
// exactly instead of DevExtreme's differently-shaped built-in checkmark glyph.
@Component({
    selector: 'app-gpd-checkbox',
    imports: [CommonModule],
    templateUrl: './gpd-checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './gpd-checkbox.component.css'
})
export class GpdCheckboxComponent {
  @Input() value = false;
  @Input() label?: string;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<boolean>();

  toggle(): void {
    if (this.disabled) return;
    // Emit only; the parent owns the value and every call site writes it back through the
    // binding. Also flipping the @Input here would let this component's rendered state drift
    // from the parent's whenever a handler declines or rewrites the change.
    this.valueChange.emit(!this.value);
  }
}
